/**
 * 全局filter文件
 */

import dayjs from 'dayjs';
/**
 * 日期
 * @param {Number} date 时间戳（s）
 * @param {String} pattern  时间格式
 * @returns 日期（2022-10-10）
 */

export const dateFilter = (date, pattern = 'YYYY-MM-DD') => {
    if (!date) {
        return '-';
    }
    return dayjs(new Date(Number(date) * 1000).getTime()).format(pattern);
};

/**
 * 城市
 * @param {String} cityName 城市编码字符串  100000$100000
 * @returns 城市（北京市）
 */

export const cityNameFilter = cityName => {
    if (!cityName) {
        return '-';
    }
    return cityName.split('$').length > 1 ? cityName.split('$')[1] || '-' : cityName;
};